import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {OrderModule} from 'ngx-order-pipe';

import {InviteResponsePipe} from './invite-response.pipe';
import {DayOfWeekMapperPipe} from './day-of-week-mapper.pipe';
import {GameStatusMapperPipe} from './game-status-mapper.pipe';
import {GetValuesFromMapPipe} from './get-values-from-map.pipe';
import {SkillLevelPipe} from './skill-level.pipe';
import {GameGenderPipe} from './game-gender.pipe';
import {StatusMapperPipe} from './status-mapper.pipe';
import {TruncatePipe} from './truncate.pipe';
import { GenderPipe } from './gender.pipe';
import { ShortenDaysPipe } from './shorten-days.pipe';
import {PlayerPositionPipe} from './player-position.pipe';
import {PlayingSidePipe} from './playing-side.pipe';
import {AgeRangePipe} from './age-range.pipe';
import { CurrencySymPipe } from './currency-sym.pipe';
import {TZDatePipe} from "./tzdate";

@NgModule({
  imports: [
    CommonModule,
    OrderModule
  ],
  declarations: [
    DayOfWeekMapperPipe,
    GameStatusMapperPipe,
    GetValuesFromMapPipe,
    StatusMapperPipe,
    InviteResponsePipe,
    SkillLevelPipe,
    GameGenderPipe,
    TruncatePipe,
    GenderPipe,
    ShortenDaysPipe,
    PlayerPositionPipe,
    PlayingSidePipe,
    AgeRangePipe,
    CurrencySymPipe,
    TZDatePipe,
  ],
  providers: [
      InviteResponsePipe,
      DayOfWeekMapperPipe,
      GameStatusMapperPipe,
      GetValuesFromMapPipe,
      SkillLevelPipe,
      GameGenderPipe,
      StatusMapperPipe,
      TruncatePipe,
      GenderPipe,
      ShortenDaysPipe,
      PlayerPositionPipe,
      PlayingSidePipe,
      AgeRangePipe,
      CurrencySymPipe,
      TZDatePipe
  ],
  exports: [
    OrderModule,
    InviteResponsePipe,
    DayOfWeekMapperPipe,
    GameStatusMapperPipe,
    GetValuesFromMapPipe,
    SkillLevelPipe,
    GameGenderPipe,
    StatusMapperPipe,
    TruncatePipe,
    GenderPipe,
    ShortenDaysPipe,
    PlayerPositionPipe,
    PlayingSidePipe,
    AgeRangePipe,
    CurrencySymPipe,
    TZDatePipe,
  ]
})
export class FMPipesModule { }
